module.exports = __webpack_public_path__ + "static/media/man-thigh.de47f62b.svg";